import React, { SyntheticEvent, useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { setCurrentLayerAction } from 'store/actions/layers';
import { getText } from 'services/languageService';
import { OptimizedAutocomplete } from 'components/UI/OptimizedAutocomplete/OptimizedAutocomplete';
import { AutocompleteChangeReason, AutocompleteValue } from '@mui/material';

export const ParamName: React.FC = () => {
  const [layer, setLayer] = useState(null);

  const { toolbarSelect, lang, isLogged } = useAppSelector(
    (state) => state.mainPage
  );
  const { currentLayerId, allChildren } = useAppSelector(
    (state) => state.layers
  );

  const dispatch = useAppDispatch();

  const handleChangeSelect = (
    event: SyntheticEvent<Element, Event>,
    value: AutocompleteValue<any, any, any, any> | null,
    reason: AutocompleteChangeReason
  ) => {
    setLayer(value);

    value
      ? dispatch(
          // @ts-ignore
          setCurrentLayerAction(
            value.layer,
            value.url,
            value.id,
            value.legend_file,
            value.map_file,
            value.meta_file,
            value.dataset_name,
            value.label,
            value.legend_size,
            value.scale_1_50,
            value.scale_1_50_vector
          )
        )
      : dispatch(setCurrentLayerAction('', '', 0, '', '', ''));
  };

  useEffect(() => {
    if (currentLayerId) {
      const curLayer = toolbarSelect.find(
        (item) => +item.id === currentLayerId
      );
      // @ts-ignore
      curLayer && setLayer(curLayer);
    }
  }, [toolbarSelect]);

  return (
    <OptimizedAutocomplete
      options={toolbarSelect}
      value={layer}
      onChange={handleChangeSelect}
      sx={{ mb: 2, p: '8px 16px 0 16px' }}
      label={getText('PARAM_NAME')}
    />
  );
};
